// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBYo43raaUZL9UJq0CS4dzo6R4-fDew5Rg',
    authDomain: 'pdpf-app-dev.firebaseapp.com',
    databaseURL: 'https://pdpf-app-dev.firebaseio.com',
    projectId: 'pdpf-app-dev',
    storageBucket: 'pdpf-app-dev.appspot.com',
    messagingSenderId: '398809718748',
    appId: '1:398809718748:web:57405f714517557758f919',
    persist: true
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
